import NoImage from './NoImage';

export default NoImage;
